import React from 'react';
import './public-site-layout.scss';

export function PublicSiteLayout({ contentLeft, contentRight, className }) {
  return (
    <div className="public-site-area">
      <section className={`background-image ${className || ''} `}>
        <div className="columns is-mobile is-gapless">
          <div className="column is-5 full-height is-hidden-mobile">{contentLeft}</div>
          <div className="column full-height is-vcentered is-centered">
            <div className="form-wrapper">
              <div className="form">{contentRight}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
